/* ALTHAUS – Interaktionen: Größenassistent, Akkordeons, Warenkorb-Fortschritt, Swatches */
(function () {
  'use strict';

  /* ---------------------------------------------------------- Utilities */
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (n, a, b) { return Math.max(a, Math.min(b, n)); };

  /* ---------------------------------------------------------- Akkordeons */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.al-acc__btn');
    if (!btn) return;
    var item = btn.closest('.al-acc__item');
    if (!item) return;
    var open = item.classList.contains('is-open');
    item.classList.toggle('is-open', !open);
    btn.setAttribute('aria-expanded', String(!open));
  });

  /* ---------------------------------------------------------- Fade-in */
  function initFade() {
    var els = $$('.al-fade:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------- Farb-Kacheln */
  // Klick auf eine ALTHAUS-Swatch-Kachel spiegelt die Auswahl in das Theme-Formular
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.al-swatch');
    if (!sw || sw.classList.contains('is-soldout')) return;
    var target = sw.getAttribute('data-for');
    if (!target) return;
    var input = document.getElementById(target);
    if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('.al-swatch[data-group="' + sw.getAttribute('data-group') + '"]').forEach(function (s) {
      s.classList.toggle('is-active', s === sw);
    });
    var lbl = $('[data-al-swatch-label="' + sw.getAttribute('data-group') + '"]');
    if (lbl) lbl.textContent = sw.getAttribute('data-name') || '';
  });

  /* ---------------------------------------------------------- Warenkorb-Fortschritt */
  var TIERS = [{ n: 2, p: 10 }, { n: 3, p: 15 }, { n: 4, p: 20 }];

  function renderProgress(count) {
    var wrap = $('#alProgress');
    if (!wrap) return;
    var fill = $('.al-prog__fill', wrap);
    var msg = $('.al-prog__msg', wrap);
    var max = TIERS[TIERS.length - 1].n;
    var pct = clamp((count / max) * 100, 0, 100);
    if (fill) fill.style.width = pct + '%';

    $$('.al-prog__tick', wrap).forEach(function (t) {
      var n = parseInt(t.getAttribute('data-n'), 10);
      t.classList.toggle('is-hit', count >= n);
    });

    if (!msg) return;
    var reached = null, next = null;
    TIERS.forEach(function (t) { if (count >= t.n) reached = t; });
    for (var i = 0; i < TIERS.length; i++) { if (count < TIERS[i].n) { next = TIERS[i]; break; } }

    if (count === 0) {
      msg.innerHTML = 'Ab 2 Artikeln sparen Sie <b>10 %</b> auf Ihre Bestellung.';
    } else if (next) {
      var miss = next.n - count;
      msg.innerHTML = 'Noch ' + miss + ' ' + (miss === 1 ? 'Artikel' : 'Artikel') +
        ' bis <b>' + next.p + ' % Rabatt</b>' + (reached ? ' – aktuell ' + reached.p + ' %' : '') + '.';
    } else {
      msg.innerHTML = 'Maximaler Vorteil erreicht: <b>' + reached.p + ' % Rabatt</b> auf Ihre Bestellung.';
    }
  }

  function syncCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderProgress(c.item_count); })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (e) {
    var c = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
    if (c === null) { syncCart(); } else { renderProgress(c); }
  });
  document.addEventListener('ajaxProduct:added', syncCart);

  function watchCart() {
    var host = $('[data-products]');
    if (!host || host.__alWatched) return;
    host.__alWatched = true;
    new MutationObserver(function () { syncCart(); }).observe(host, { childList: true, subtree: true });
  }

  /* ---------------------------------------------------------- Größenassistent */
  var SA = {
    state: {}, cfg: null, step: 0,

    readContext: function () {
      var host = $('#alSizeAssistant');
      var titleEl = $('.product-single__title') || $('.product__title') || $('h1');
      var title = (titleEl ? titleEl.textContent : '').toLowerCase();

      var gender = /herren|m\u00e4nner|men\b/.test(title) ? 'men' : 'women';
      var kind = 'apparel';
      if (/schuh|sneaker|stiefel|sandale|loafer|pumps|ballerina|slipper|boots|mokassin|clogs|espadrille|pantolette|halbschuh/.test(title)) kind = 'shoes';
      else if (/jacke|mantel|parka|blazer|weste|trenchcoat|cape|poncho/.test(title)) kind = 'outerwear';
      else if (/kleid/.test(title)) kind = 'dress';

      // Größen aus dem Varianten-Formular lesen
      var wrap = null;
      $$('fieldset.variant-input-wrap').forEach(function (fs) {
        var h = (fs.getAttribute('data-handle') || '') + ' ' + (fs.getAttribute('name') || '');
        if (/gr\u00f6\u00dfe|gr\u00f6sse|grosse|size/i.test(h)) wrap = fs;
      });
      if (!wrap) wrap = $('.al-sizes');

      var sizes = [];
      if (wrap) {
        $$('.variant-input', wrap).forEach(function (vi) {
          var input = vi.querySelector('input[type=radio]');
          var label = vi.querySelector('label');
          if (!input) return;
          sizes.push({
            value: input.value,
            inputId: input.id,
            available: !(label && (label.classList.contains('is-soldout') || label.classList.contains('disabled')))
          });
        });
      }

      return {
        kind: kind,
        gender: gender,
        email: (host && host.getAttribute('data-email')) || 'info@althausmode.com',
        sizes: sizes
      };
    },

    open: function (trigger) {
      var host = $('#alSizeAssistant');
      if (!host) return;
      SA.cfg = SA.readContext();
      SA.state = {}; SA.step = 0;
      host.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      SA.render();
      SA.trigger = trigger || null;
    },

    close: function () {
      var host = $('#alSizeAssistant');
      if (!host) return;
      host.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (SA.trigger) { try { SA.trigger.focus(); } catch (e) {} }
    },

    steps: function () {
      var kind = (SA.cfg && SA.cfg.kind) || 'apparel';
      if (kind === 'shoes') return ['feet', 'width', 'result'];
      return ['body', 'build', 'fit', 'result'];
    },

    render: function () {
      var body = $('#alSaBody');
      if (!body) return;
      var steps = SA.steps();
      var key = steps[SA.step];
      var dots = steps.slice(0, -1).map(function (s, i) {
        return '<span class="al-sa__dot' + (i <= SA.step ? ' is-done' : '') + '"></span>';
      }).join('');
      var html = '<div class="al-sa__steps">' + dots + '</div>';

      if (key === 'body') {
        html += '<p class="al-sa__q">Wie groß sind Sie und wie viel wiegen Sie?</p>' +
          '<p class="al-sa__hint">Beides bleibt bei Ihnen im Browser – wir speichern nichts.</p>' +
          '<div class="al-sa__err" id="alSaErr">Bitte tragen Sie realistische Werte ein (Größe 130–210 cm, Gewicht 35–200 kg).</div>' +
          '<div class="al-sa__field"><input id="alSaH" type="number" inputmode="numeric" placeholder="Körpergröße" value="' + (SA.state.h || '') + '"><span class="al-sa__unit">cm</span></div>' +
          '<div class="al-sa__field"><input id="alSaW" type="number" inputmode="numeric" placeholder="Gewicht" value="' + (SA.state.w || '') + '"><span class="al-sa__unit">kg</span></div>' +
          '<div class="al-sa__nav"><button type="button" class="al-btn al-btn--block" data-sa-next>Weiter</button></div>';
      }

      if (key === 'build') {
        html += '<p class="al-sa__q">Wie würden Sie Ihre Statur beschreiben?</p>' +
          '<p class="al-sa__hint">Das verfeinert die Empfehlung um bis zu eine Konfektionsgröße.</p>' +
          '<div class="al-sa__opts al-sa__opts--3">' +
          SA.opt('build', 'slim', 'Zierlich', 'schmale Schultern & Hüfte') +
          SA.opt('build', 'normal', 'Durchschnittlich', 'ausgewogene Proportionen') +
          SA.opt('build', 'strong', 'Kräftiger', 'breitere Schultern oder Hüfte') +
          '</div><div class="al-sa__nav"><button type="button" class="al-sa__back" data-sa-back>Zurück</button></div>';
      }

      if (key === 'fit') {
        var isOuter = SA.cfg && SA.cfg.kind === 'outerwear';
        if (isOuter) {
          html += '<p class="al-sa__q">Was tragen Sie meistens darunter?</p>' +
            '<p class="al-sa__hint">Jacken und Mäntel brauchen je nach Lage etwas mehr Raum.</p>' +
            '<div class="al-sa__opts al-sa__opts--3">' +
            SA.opt('fit', 'tight', 'Shirt oder Bluse', 'schmale Lage') +
            SA.opt('fit', 'normal', 'Feiner Pullover', 'der Normalfall') +
            SA.opt('fit', 'loose', 'Dicker Strick', 'viel Volumen') +
            '</div>';
        } else {
          html += '<p class="al-sa__q">Wie soll das Teil sitzen?</p>' +
            '<p class="al-sa__hint">Im Zweifel wählen Sie „Normal" – so ist der Schnitt gedacht.</p>' +
            '<div class="al-sa__opts al-sa__opts--3">' +
            SA.opt('fit', 'tight', 'Figurbetont', 'eng am Körper') +
            SA.opt('fit', 'normal', 'Normal', 'wie entworfen') +
            SA.opt('fit', 'loose', 'Locker', 'oversized getragen') +
            '</div>';
        }
        html += '<div class="al-sa__nav"><button type="button" class="al-sa__back" data-sa-back>Zurück</button></div>';
      }

      if (key === 'feet') {
        html += '<p class="al-sa__q">Welche Schuhgröße tragen Sie normalerweise?</p>' +
          '<p class="al-sa__hint">Europäische Größe. Wenn Sie unsicher sind: Fußlänge in cm messen und 1,5 cm addieren – das ergibt ungefähr Ihre EU-Größe.</p>' +
          '<div class="al-sa__err" id="alSaErr">Bitte eine Größe zwischen 33 und 50 eintragen.</div>' +
          '<div class="al-sa__field"><input id="alSaEu" type="number" inputmode="numeric" placeholder="z. B. 39" value="' + (SA.state.eu || '') + '"><span class="al-sa__unit">EU</span></div>' +
          '<div class="al-sa__nav"><button type="button" class="al-btn al-btn--block" data-sa-next>Weiter</button></div>';
      }

      if (key === 'width') {
        html += '<p class="al-sa__q">Wie breit ist Ihr Fuß?</p>' +
          '<p class="al-sa__hint">Bei breiten Füßen empfehlen wir eine halbe bis ganze Größe mehr.</p>' +
          '<div class="al-sa__opts al-sa__opts--3">' +
          SA.opt('width', 'narrow', 'Eher schmal', 'Schuhe sitzen oft locker') +
          SA.opt('width', 'normal', 'Normal', 'passt meistens') +
          SA.opt('width', 'wide', 'Eher breit', 'Schuhe drücken oft seitlich') +
          '</div><div class="al-sa__nav"><button type="button" class="al-sa__back" data-sa-back>Zurück</button></div>';
      }

      if (key === 'result') html += SA.result();

      body.innerHTML = html;
      var first = $('#alSaH') || $('#alSaEu');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    },

    opt: function (field, val, title, sub) {
      return '<button type="button" class="al-sa__opt' + (SA.state[field] === val ? ' is-active' : '') +
        '" data-sa-set="' + field + '" data-sa-val="' + val + '">' + title +
        '<small>' + sub + '</small></button>';
    },

    /* ---- Berechnung ---- */
    calcApparel: function () {
      var cfg = SA.cfg || {};
      var gender = cfg.gender === 'men' ? 'men' : 'women';
      var h = parseFloat(SA.state.h), w = parseFloat(SA.state.w);
      var ref = gender === 'men' ? 180 : 168;
      var slope = gender === 'men' ? 0.60 : 0.45;
      var adj = w - (h - ref) * slope;

      var scale = gender === 'men'
        ? [['XS', 62], ['S', 70], ['M', 80], ['L', 90], ['XL', 101], ['2XL', 113], ['3XL', 999]]
        : [['XS', 52], ['S', 58], ['M', 66], ['L', 75], ['XL', 85], ['2XL', 97], ['3XL', 999]];

      var idx = scale.length - 1;
      for (var i = 0; i < scale.length; i++) { if (adj < scale[i][1]) { idx = i; break; } }

      if (SA.state.build === 'slim') idx -= 1;
      if (SA.state.build === 'strong') idx += 1;
      if (SA.state.fit === 'tight') idx -= 1;
      if (SA.state.fit === 'loose') idx += 1;
      if (cfg.kind === 'outerwear' && SA.state.fit === 'loose') idx += 0;
      if (cfg.kind === 'dress' && SA.state.build === 'strong') idx += 0;

      idx = clamp(idx, 0, scale.length - 1);
      return { label: scale[idx][0], idx: idx, scale: scale.map(function (s) { return s[0]; }) };
    },

    calcShoes: function () {
      var eu = parseFloat(SA.state.eu);
      if (SA.state.width === 'wide') eu += 1;
      if (SA.state.width === 'narrow') eu -= 0;
      return { label: String(Math.round(eu)) };
    },

    /* ---- Passenden Variantenwert im Shop finden ---- */
    matchOption: function (label) {
      var vals = (SA.cfg && SA.cfg.sizes) || [];
      var norm = function (s) {
        return String(s).toUpperCase()
          .replace(/\s+/g, '')
          .replace('EU', '')
          .replace(/XXXL/g, '3XL').replace(/XXL/g, '2XL');
      };
      var t = norm(label);
      // 1. exakt
      for (var i = 0; i < vals.length; i++) { if (norm(vals[i].value) === t) return vals[i]; }
      // 2. enthält (z. B. "M(8-10)" oder "EU 39")
      for (var j = 0; j < vals.length; j++) {
        var v = norm(vals[j].value);
        if (v.indexOf(t) === 0 || v === t) return vals[j];
      }
      for (var k = 0; k < vals.length; k++) {
        if (norm(vals[k].value).replace(/[^0-9A-Z]/g, '').indexOf(t) === 0) return vals[k];
      }
      return null;
    },

    result: function () {
      var kind = (SA.cfg && SA.cfg.kind) || 'apparel';
      var r = kind === 'shoes' ? SA.calcShoes() : SA.calcApparel();
      var hit = SA.matchOption(r.label);
      var mailto = 'mailto:' + ((SA.cfg && SA.cfg.email) || 'info@althausmode.com') +
        '?subject=' + encodeURIComponent('Persönliche Größenberatung');

      var html = '<div class="al-sa__result">' +
        '<div class="al-sa__badge">' + (hit ? hit.value : r.label) + '</div>' +
        '<p class="al-sa__rtitle">Das ist Ihre Größe für dieses Modell.</p>';

      if (kind === 'shoes') {
        html += '<p class="al-sa__rtext">Berechnet aus Ihrer gewohnten EU-Größe und Ihrer Fußbreite. Sitzt der Schuh nicht, senden Sie ihn innerhalb von 90 Tagen zurück.</p>';
      } else {
        html += '<p class="al-sa__rtext">Berechnet aus Größe, Gewicht, Statur und gewünschtem Sitz – abgestimmt auf den Schnitt dieses Modells.</p>';
      }

      if (hit && hit.available) {
        html += '<button type="button" class="al-btn al-btn--block" data-sa-add="' + hit.id + '" data-sa-input="' + hit.inputId + '">Größe ' + hit.value + ' in den Warenkorb</button>';
      } else if (hit && !hit.available) {
        html += '<p class="al-sa__rtext"><b>Größe ' + hit.value + ' ist derzeit ausverkauft.</b> Schreiben Sie uns – wir sagen Ihnen, wann sie wieder da ist.</p>' +
          '<a class="al-btn al-btn--ghost al-btn--block" href="' + mailto + '">Benachrichtigung anfragen</a>';
      } else {
        html += '<p class="al-sa__rtext">Dieses Modell wird in einer anderen Größenlogik geführt. Schreiben Sie uns kurz Ihre Maße – wir melden uns meist innerhalb weniger Stunden.</p>' +
          '<a class="al-btn al-btn--ghost al-btn--block" href="' + mailto + '">Persönliche Beratung anfragen</a>';
      }

      html += '<p class="al-sa__alt">Zwischen zwei Größen? Bei Strick und Mänteln nehmen Sie die größere. ' +
        'Unsicher? <a href="' + mailto + '">' + ((SA.cfg && SA.cfg.email) || 'info@althausmode.com') + '</a> – wir beraten Sie persönlich.</p>' +
        '<div class="al-sa__nav" style="margin-top:14px"><button type="button" class="al-sa__back" data-sa-back>Angaben ändern</button></div>' +
        '</div>';
      return html;
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target;

    var opener = t.closest('[data-sa-open]') || t.closest('a[href="#groessenassistent"]');
    if (opener) { e.preventDefault(); SA.open(opener); return; }
    if (t.closest('[data-sa-close]') || t.closest('.al-modal__veil')) { SA.close(); return; }

    var setBtn = t.closest('[data-sa-set]');
    if (setBtn) {
      SA.state[setBtn.getAttribute('data-sa-set')] = setBtn.getAttribute('data-sa-val');
      SA.step = Math.min(SA.step + 1, SA.steps().length - 1);
      SA.render();
      return;
    }

    if (t.closest('[data-sa-next]')) {
      var steps = SA.steps(), key = steps[SA.step];
      if (key === 'body') {
        var h = parseFloat(($('#alSaH') || {}).value), w = parseFloat(($('#alSaW') || {}).value);
        if (!(h >= 130 && h <= 210 && w >= 35 && w <= 200)) { var er = $('#alSaErr'); if (er) er.classList.add('is-on'); return; }
        SA.state.h = h; SA.state.w = w;
      }
      if (key === 'feet') {
        var eu = parseFloat(($('#alSaEu') || {}).value);
        if (!(eu >= 33 && eu <= 50)) { var er2 = $('#alSaErr'); if (er2) er2.classList.add('is-on'); return; }
        SA.state.eu = eu;
      }
      SA.step = Math.min(SA.step + 1, steps.length - 1);
      SA.render();
      return;
    }

    if (t.closest('[data-sa-back]')) { SA.step = Math.max(0, SA.step - 1); SA.render(); return; }

    var add = t.closest('[data-sa-add]');
    if (add) {
      var inputId = add.getAttribute('data-sa-input');
      var input = inputId ? document.getElementById(inputId) : null;
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      var form = $('form[action*="/cart/add"]');
      var submit = form ? form.querySelector('[type="submit"]') : null;
      SA.close();
      setTimeout(function () {
        if (submit) { submit.click(); }
        else if (form) { form.submit(); }
      }, 220);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') SA.close();
  });

  /* ------------------------------------------- Produkttitel bereinigen */
  // Ein Teil der Titel im Katalog beginnt mit einem Anfuehrungszeichen.
  function cleanTitles() {
    $$('.product-single__title,.grid-product__title,.al-ci__title,.product__title').forEach(function (el) {
      if (el.getAttribute('data-al-clean')) return;
      var t = el.textContent;
      var c = t.replace(/^[\s"'\u201C\u201E\u00AB]+/, '').replace(/[\s"'\u201D\u00BB]+$/, '');
      if (c !== t) el.textContent = c;
      el.setAttribute('data-al-clean', '1');
    });
  }

  /* ---------------------------------------------------------- Init */
  function init() { initFade(); watchCart(); syncCart(); cleanTitles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', cleanTitles);
})();
